import { Component } from '@angular/core';
import { RevealDirective } from '../../../directives/reveal.directive';

@Component({
  selector: 'app-benefits',
  standalone: true,
  imports: [RevealDirective],
  templateUrl: './benefits.component.html',
})
export class BenefitsComponent {}
